/**
 * Extract voucher codes from URL parameters
 * Supports both ?voucher=CODE1&voucher=CODE2 and ?voucher=CODE1,CODE2 formats
 */
export function getVoucherCodesFromUrl(): string[] {
  const params = new URLSearchParams(window.location.search);
  const codes: string[] = [];

  // Handle multiple voucher params: ?voucher=CODE1&voucher=CODE2
  params.getAll('voucher').forEach((voucher) => {
    // Handle comma-separated values: ?voucher=CODE1,CODE2
    voucher.split(',').forEach((code) => {
      const trimmed = code.trim();
      if (trimmed && !codes.includes(trimmed)) {
        codes.push(trimmed);
      }
    });
  });

  return codes;
}

/**
 * Update URL with voucher codes without page reload
 */
export function updateUrlWithVoucherCodes(codes: string[]): void {
  const url = new URL(window.location.href);
  
  // Remove existing voucher params
  url.searchParams.delete('voucher');
  
  // Add new voucher codes
  if (codes.length > 0) {
    codes.forEach((code) => {
      url.searchParams.append('voucher', code);
    });
  }

  // Update URL without reload
  window.history.replaceState({}, '', url.toString());
}

/**
 * Get voucher codes from localStorage
 */
export function getVoucherCodesFromStorage(): string[] {
  try {
    const stored = localStorage.getItem('intan_voucher_codes');
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    console.error('Error reading voucher codes from storage:', error);
  }
  return [];
}

/**
 * Save voucher codes to localStorage
 */
export function saveVoucherCodesToStorage(codes: string[]): void {
  try {
    localStorage.setItem('intan_voucher_codes', JSON.stringify(codes));
  } catch (error) {
    console.error('Error saving voucher codes to storage:', error);
  }
}

/**
 * Merge voucher codes from URL and storage, removing duplicates
 */
export function mergeVoucherCodes(): string[] {
  const urlCodes = getVoucherCodesFromUrl();
  const storageCodes = getVoucherCodesFromStorage();
  
  // Combine and deduplicate
  const allCodes = [...urlCodes, ...storageCodes];
  return Array.from(new Set(allCodes));
}

